// src/integrations/Core.js
// Forwarder robusto verso lo stub locale (@base44/sdk è aliased in vite.config.js)

import sdkDefault, * as sdk from '@base44/sdk';

// Prende Integrations/Core da più posti possibili (named, default, globali)
const base =
  (sdk && sdk.Integrations) ||
  (sdkDefault && sdkDefault.Integrations) ||
  (typeof window !== 'undefined' ? window.Integrations : null) ||
  {};

let Core =
  base.Core ||
  (sdk && sdk.Core) ||
  (sdkDefault && sdkDefault.Core) ||
  (typeof window !== 'undefined' ? window.Core : null);

// Fallback innocuo se ancora assente (non rompe la UI)
if (!Core) {
  Core = {
    UploadFile: async (file) => {
      console.log('[fallback Core.UploadFile]', file?.name || typeof file);
      const blob =
        file instanceof Blob
          ? file
          : new Blob([String(file ?? '')], { type: 'text/plain' });
      return { ok: true, url: URL.createObjectURL(blob) };
    },
    InvokeLLM: async ({ prompt, model = 'local-stub', temperature = 0.2 } = {}) => {
      console.log('[fallback Core.InvokeLLM]', { prompt, model, temperature });
      return { ok: true, content: '🤖 (stub) Risposta simulata', model, temperature };
    },
    SendEmail: async ({ to, subject, html } = {}) => {
      console.log('[fallback Core.SendEmail]', {
        to,
        subject,
        htmlLen: (html || '').length,
      });
      return { ok: true };
    },
  };
}

export { Core };
export const Integrations = { Core };
export default { Core, Integrations };
